export enum PanelOutputType {
  Door = 'DOOR',
  Other = 'OTHER'
}
